export class FpaAdditionalData {

  entityId!: string;
  competitorId!: number;
  iecListedEqual!: boolean;
  specifyingEngineer!: string;
  engineerLocation!: string;
  targetPrice!: number;
  otherDetails!: string;
  projectBidDate!: Date;
  basisOfDesign!: number;
  expectedFirstShipment!: string;
  approvedListPrice!: number;

}
